import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class VariantPackage extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updatePackage);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updatePackage);
  }

  /**
   * Updates the package.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePackage = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    } 
    
    const newPackage = event.detail.data.html.querySelector('variant-package');

    if (!newPackage) return;

    morph(this, newPackage, { childrenOnly: true });
  };
}

if (!customElements.get('variant-package')) {
  customElements.define('variant-package', VariantPackage);
}
